import { createStyles, makeStyles, Theme } from '@material-ui/core';
import Colors from '../Colors';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    sectionContainer: {
      margin: '15px 0 5px 0',
      width: '100%',
      padding: 20,
      backgroundColor: '#eaeaea',
      boxShadow: theme.shadows[2],
      borderRadius: 3,
    },
    searchBar: {
      display: 'flex',
      alignItems: 'flex-end',
      marginBottom: 15,
    },
    buttonSearch: {
      height: 40,
      width: '100%',
      minWidth: 110,
      backgroundColor: Colors.main,
      fontFamily: 'Texta Medium',
      letterSpacing: '1px',
      color: Colors.white,
      [theme.breakpoints.down('sm')]: {},
      '&:hover': {
        backgroundColor: Colors.secundary,
        fontFamily: 'Texta Heavy',
      },
    },
    mapContainer: {
      margin: '0 0 30px 0',
      width: '100%',
      height: 350,
      backgroundColor: 'white',
    },
    textField: {
      width: '100%',
      marginTop: 10,
      minWidth: 220,
      backgroundColor: 'white',
    },
    label: {
      marginTop: 5,
      fontFamily: 'Roboto',
      fontSize: 14,
      alignSelf: 'start',
      color: '#000000',
    },
    input: {
      marginTop: 10,
      height: 40,
      width: '100%',
      border: '1px solid #ccc',
      backgroundColor: 'white',
      overflow: 'hidden',
      borderRadius: 4,
      padding: 10.5,
      boxSizing: 'border-box',
      '&:hover': {
        borderColor: 'black',
      },
      '&:focus': {
        border: '1.5px solid #3f51b5',
      },
      // Ocultar setas de incremento e decremento
      '&[type=number]::-webkit-outer-spin-button, &[type=number]::-webkit-inner-spin-button': {
        '-webkit-appearance': 'none',
        margin: 0,
      },
      '&[type=number]': {
        '-moz-appearance': 'textfield', // Firefox
      },
    },
    errorIput: {
      border: '1px solid red',
      '&:hover': {
        borderColor: 'red',
      },
      '&:focus': {
        border: '1.5px solid red',
      },
    },
    select: {
      marginTop: 10,
      height: 40,
      width: '100%',
      backgroundColor: 'white',
      '& div': {
        '&:focus': {
          backgroundColor: 'transparent',
        },
      },
    },
  }),
);
